import { Vector3 } from "three";

export default class LineSegment3d {
    p1: Vector3;
    p2: Vector3;
    
    constructor(p1: Vector3, p2: Vector3) {
        this.p1 = p1;
        this.p2 = p2;
    }

    length(): number {
        return this.p1.distanceTo(this.p2);
    }

    midpoint(): Vector3 {
        return new Vector3(
            (this.p1.x + this.p2.x) / 2,
            (this.p1.y + this.p2.y) / 2,
            (this.p1.z + this.p2.z) / 2
        );
    }

    direction(): Vector3 {
        const dir = new Vector3().subVectors(this.p2, this.p1);
        return dir.normalize();
    }

    points(): Vector3[] {
        return [this.p1.clone(), this.p2.clone()];
    }
}